import React, { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import {
  clearSpaceTemplate,
  deleteSpaceTemplate,
  fetchSpacesTemplates,
} from "app/actions/spaceTemplate";
import { useActions, useSelector } from "app/utils/hooks";
import TemplateCard from "./TemplateCard";
import NoPosts from "app/components/NoResults/NoPosts";
import { useTranslation } from "react-i18next";
import { RootState } from "typedefs";
import { shallowEqual } from "react-redux";
import { Loading } from "app/components/Wrappers";
import customPrompt from "app/components/inputs/SelectBox/helpers/customPrompt";

const TemplatesList = () => {
  const { t } = useTranslation();
  const templateActions = useActions({
    fetchSpacesTemplates,
    deleteSpaceTemplate,
    clearSpaceTemplate,
  });

  const [templates, setTemplates] = useState<any>([]);
  const { pending } = useSelector(
    (state: RootState) => state.spaceTemplate,
    shallowEqual,
  );

  useEffect(() => {
    templateActions.fetchSpacesTemplates().then((res: any) => {
      res.sort((a: any, b: any) => {
        return a.name.localeCompare(b.name);
      });

      setTemplates(res);
    });

    return () => {
      setTemplates([]);
      templateActions.clearSpaceTemplate();
    };
  }, []);

  const onDelete = (id: string) => {
    const template = templates.find((tpl: any) => tpl.id === id);
    customPrompt({
      message: template?.name
        ? t(`Are you sure you would like to delete {{name}}?`, {
            name: template.name,
          })
        : t(`Are you sure you would like to delete this template?`),
      onYes: () => {
        templateActions.deleteSpaceTemplate(id).then(() => {
          setTemplates((prev: any) => {
            return prev.filter((tpl: any) => tpl.id !== id);
          });
        });
      },
      onCancel: () => {
        return;
      },
    });
  };

  if (templates?.length === 0 && pending) {
    return <Loading isLoading={pending} loadType="spinner" />;
  }

  if (templates?.length === 0 && !pending) {
    return (
      <NoPosts
        title={t("No Templates Yet")}
        description={t(
          "Templates make it easy to create the same content for any number of Spaces or Teams.",
        )}
      />
    );
  }

  return (
    <div className={styles.container}>
      {templates?.map((template: any) => {
        return (
          <TemplateCard
            template={template}
            key={template.id}
            onDelete={onDelete}
          />
        );
      })}
    </div>
  );
};

export default TemplatesList;
